import { createStyles, makeStyles, Theme } from '@material-ui/core';

const styles = (theme: Theme) => createStyles({
  disabled: {
    color: '#000000',
  },
  inputRoot: {
    '& .MuiFilledInput-root': {
      '&:-internal-autofill-selected ': {
        backgroundColor: theme.appPalette.orange,
      },
    },
    '& .MuiFilledInput-underline:after': {
      borderBottomColor: theme.appPalette.orange,
    },
    '& label.Mui-focused, label.MuiFormLabel-root': {
      color: theme.appPalette.orange,
    },
  },
});

const useStyles = makeStyles(styles);

export default useStyles;
